import { useTranslation } from '@vitvio/locales';
import type { ReactNode } from 'react';

export type TranslationValue = Record<string, string | number | boolean>;

// Translation hook that handles the translation logic
export function useTranslatedContent(path?: string, value?: TranslationValue): ReactNode {
  const { t } = useTranslation();
  return typeof path === 'string' ? t(path, value) : null;
}

// Generic Translation component that wraps any component with translation functionality
export interface TranslationProps {
  path?: string;
  children?: ReactNode;
  value?: TranslationValue;
  render: (content: ReactNode) => ReactNode;
}

export function Translation({ path, children, value, render }: TranslationProps) {
  const content = useTranslatedContent(path, value);
  return render(
    <>
      {content}
      {children}
    </>,
  );
}
